/**
 * Created by rhett on 2019/4/12.
 */
const SERVER_API = "/activity/server";
export default class Gateway
{



  _gwUserVerifyCb = null;
  // 由于不是用微信登录，所以登录在此会话内
  gwUserVerify(cb)
  {
    this._gwUserVerifyCb = cb;
    this.gwSimpleGet("/user/verify",{},cb);
  }


  gwSimpleCall(api, extraArg, cb,errCb)
  {
    let formData = new FormData();
    for (let eachKey in extraArg)
    {
      formData.append(eachKey, extraArg[eachKey]);
    }

    fetch(SERVER_API + api, {method: "post",credentials:"include", body: formData})
      .then(function (response)
      {
        return response.json();
      })
      .then(function (resp)
      {
        if (resp.error == 0)
        {
          cb(resp.data);
        } else
        {
          let isSwallow = false;
          if ( errCb !=null )
             isSwallow = errCb(resp);
          if (!isSwallow)alert(resp.message);
        }

      }.bind(this)).catch((error) =>
    {
      console.error(error);
    });

  }

  gwSimpleGet(api,extraArg,cb)
  {
    let url = SERVER_API + api;
    if(extraArg)
    {
      let args = [];
      for (let eachKey in extraArg)
      {
        args.push(eachKey +"="+ extraArg[eachKey]);
      }
      if(args.length)
        url = url + "?" + args.join("&");
    }
    fetch(url, {method: "get",credentials:"include"})
      .then(function (response)
      {
        return response.json();
      })
      .then(function (resp)
      {
        if (resp.error == 0)
        {
          cb(resp.data);
        } else
        {
          alert(resp.message);
        }

      }.bind(this)).catch((error) =>
    {
      console.error(error);
    })
  }

  gwJoin(id ,members,time, cb )
  {
    this.gwSimpleCall("/activity/join",{id ,members,time},cb);
  }

  gwSendSms(phone , cb )
  {
    this.gwSimpleGet("/user/sendSms",{phone},cb);
  }
  gwLogin(phone,code,cb,errCb)
  {
    this.gwSimpleCall("/user/login",{phone,code} ,cb ,errCb );
  }

  gwActivityFind( id ,cb )
  {
    this.gwSimpleGet("/activity/find",{id : id},cb);
  }

}